import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-class',
  templateUrl: './view-class.component.html',
  styleUrls: ['./view-class.component.scss']
})
export class ViewClassComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
